import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuthState } from "../hooks/useAuthState"
import { CircularProgress } from '@mui/material';
import { updateUserProfile } from "../utils/userProfile"
import { useUserProfile } from "../context/user/useProfileProfile"
// import BackgroundImage from "../assets/shutterstock_background.png"
// import FanFestLogo from "../assets/FanFest_Logo.png"
// import './AuthRedirectPage';

import { ROUTES } from "../routes/routeConstants";

import './AuthCallback.css';

const AuthCallback = ({ fallbackComponent }) => {
  const navigate = useNavigate();
  const { createProfile } = useUserProfile();
  const [error, setError] = useState(null);

  // Get auth state hook
  const { waitForAuthentication } = useAuthState();

  useEffect(() => {
    const processAuthCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');

      if (!code) {
        // No OAuth code, render fallback
        return;
      }

      try {
        console.log('[AuthCallback] Waiting for authentication...');
        // Wait for authentication to complete
        const isAuthenticated = await waitForAuthentication();
        console.log('[AuthCallback] Authentication result:', isAuthenticated);

        if (isAuthenticated && window.nbc?.identity?.user) {
          console.log('🔍 [AuthCallback] User authenticated, updating profile...');
          // Update user profile
          const userProfile = updateUserProfile(window.nbc.identity.user);
          await createProfile(userProfile);

          // Show success state briefly
          await new Promise(resolve => setTimeout(resolve, 1000));
          console.log('[AuthCallback] Navigating to home...');
          // Navigate to home page
          navigate(ROUTES.HOME, { replace: true });
        } else {
          throw new Error("Authentication failed");
        }
      } catch (error) {
        console.error("[AuthCallback] Error processing auth callback:", error);
        setError(error.message || "Authentication failed. Please try a different browser.");
        // Show error state briefly
        await new Promise(resolve => setTimeout(resolve, 2000));
        console.log('[AuthCallback] Navigating to login...');
        navigate(ROUTES.LOGIN, { replace: true });
      }
    };

    processAuthCallback();
  }, [navigate, createProfile, waitForAuthentication]);

  // If we have OAuth parameters, show loading screen
  const params = new URLSearchParams(window.location.search);
  const code = params.get('code');
  const state = params.get('state');

  if (code && state) {
    return (
      <div
        className="min-h-[100dvh] w-full" style={{background: '#000000'}}
        // style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <div className="w-full h-full max-w-md mx-auto flex flex-col items-center justify-center py-6 px-4 space-y-6">
          <div className="flex-shrink-0">
            {/* <img 
              src={FanFestLogo || "/placeholder.svg"} 
              alt="Fan Fest Logo" 
              className="w-auto h-12 sm:h-16" 
            /> */}
          </div>

          {error ? (
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-red-500 flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </div>
          ) : (
            <div className="flex-shrink-0 w-12 h-12 rounded-full border-3 border-t-[#D243FD] border-r-[#95FAFF] border-b-[#D243FD] border-l-[#95FAFF] animate-spin"></div>
          )}

          <div className="w-full text-center">
            {/* <h2 className="text-[0.6em] font-bold text-white mb-1">
              {error ? "Loading..." : "Loading..."}
            </h2> */}
            <CircularProgress size={50} style={{
              margin: '40px auto 30px auto',
              display: 'block',
              color: '#0080ff'
            }}  sx={{ color: '#000000' }} />
            <p className="text-[0.5em] text-white/90">
              {error ? error : "Please wait while we get everything ready..."}
            </p>
          </div>
        </div>
      </div>
    );
  }

  // No OAuth parameters, render the fallback component
  return fallbackComponent;
}

export default AuthCallback

